import ChatIndexRoute from './ChatIndexRoute';
export default ChatIndexRoute;
